export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// /Users/dmp/Code/cohen.onf.ca/node_modules/topojson-client/src/identity.js
// module id = null
// module chunks = 